import { render, staticRenderFns } from "./ShareSettingDialog.vue?vue&type=template&id=3165fe6a&scoped=true"
import script from "./ShareSettingDialog.vue?vue&type=script&lang=js"
export * from "./ShareSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareSettingDialog.vue?vue&type=style&index=0&id=3165fe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165fe6a",
  null
  
)

export default component.exports